export class PasswordResetRequest {
  public companyGuid: string;
  public email: string;
  public includeResetCode?: boolean;

  constructor(companyGuid: string, email: string, includeResetCode: boolean) {
    this.companyGuid = companyGuid;
    this.email = email;
    this.includeResetCode = includeResetCode
  }
}

export class AccountPasswordResetRequest {
  public companyGuid: string;
  public email: string;
  public resetCode: string;
  public newPassword: string;

  constructor(companyGuid: string, email: string, resetCode: string, newPassword: string) {
    this.companyGuid = companyGuid;
    this.email = email;
    this.resetCode = resetCode;
    this.newPassword = newPassword;
  }
}
